import { c as _c } from "react/compiler-runtime";
import React, { useRef, type JSX } from 'react';
import EmptyList from 'shared/components/table/components/empty-list';
import { InstanceForPaginationType } from 'shared/components/table/types/instance-interface';
import { DataWithPaginationInterface, LimitType, PaginationInterface } from 'shared/types/pagination-interface';
import { twJoin } from 'tailwind-merge';
import { ColumnDefinitionInterface } from '../types/column-interface';
import { calculateTableTotalWidth } from '../utils';
import { TableHeader } from './table-header';
import TableLimitPagination from './table-limit-pagination';
import { TableRows } from './table-rows';
export interface BaseTableProps<T> {
  data: DataWithPaginationInterface<T> | undefined;
  /**
   * @deprecated
   * ure **rowIdParser** instead
   */
  nestedId?: keyof T;
  /**
   * @deprecated
   * ure **rowIdParser** instead
   */
  paginationIdField?: { [K in keyof T]: T[K] extends string | number ? K : never }[keyof T];
  rowIdParser?: (row: T) => string | number;
  type?: 'large' | 'small';
  columns: ColumnDefinitionInterface<T>[];
  limiter?: {
    limit: LimitType;
    setLimit: React.Dispatch<React.SetStateAction<LimitType>>;
  };
  paginator?: {
    pagination: PaginationInterface;
    setPagination: React.Dispatch<React.SetStateAction<PaginationInterface>>;
  };
  testAttributePostfix?: string;
  noHeader?: boolean;
  firstLineRect?: boolean;
  emptyListWithTitles?: boolean;
  onRowClick?: (instance: T) => void;
  withBorders?: boolean;
  isSortable?: boolean;
  footerAdditionalElement?: JSX.Element;
  rowClassName?: string | ((instance: T) => string);
}
export function BaseTable(t0) {
  const $ = _c(22);
  const {
    data,
    nestedId,
    paginationIdField,
    rowIdParser,
    type: t1,
    columns,
    limiter,
    paginator,
    testAttributePostfix,
    noHeader,
    firstLineRect,
    onRowClick,
    emptyListWithTitles,
    withBorders,
    isSortable,
    footerAdditionalElement,
    rowClassName
  } = t0;
  const type = t1 === undefined ? "large" : t1;
  let t2;
  let visibleColumns;
  if ($[0] !== columns) {
    visibleColumns = columns.filter(_temp);
    t2 = calculateTableTotalWidth(visibleColumns);
    $[0] = columns;
    $[1] = t2;
    $[2] = visibleColumns;
  } else {
    t2 = $[1];
    visibleColumns = $[2];
  }
  const totalWidth = t2;
  const tableRef = useRef(null);
  let t3;
  if ($[3] !== data || $[4] !== emptyListWithTitles || $[5] !== firstLineRect || $[6] !== footerAdditionalElement || $[7] !== isSortable || $[8] !== limiter || $[9] !== nestedId || $[10] !== noHeader || $[11] !== onRowClick || $[12] !== paginationIdField || $[13] !== paginator || $[14] !== rowClassName || $[15] !== rowIdParser || $[16] !== testAttributePostfix || $[17] !== totalWidth || $[18] !== type || $[19] !== visibleColumns || $[20] !== withBorders) {
    t3 = !data || data.items.length !== 0 || emptyListWithTitles || paginator?.pagination.startFromId ? <div className="flex w-full flex-col gap-3" ref={tableRef} data-test="table"><div className={`overflow-x-hidden ${firstLineRect ? "rounded-b-lg" : "rounded-lg"} ${withBorders && "border-text-primary/15 border"}`} data-test-table-is-loaded={!!data}>{!noHeader && <TableHeader columns={visibleColumns} totalWidth={totalWidth} />}<TableRows limiter={limiter} nestedId={nestedId} paginationIdField={paginationIdField} rowIdParser={rowIdParser} onRowClick={onRowClick} totalWidth={totalWidth} type={type} data={data} columns={visibleColumns} testAttributePostfix={testAttributePostfix} noHeader={noHeader} firstLineRect={firstLineRect} emptyListWithTitles={emptyListWithTitles} withBorders={withBorders} isSortable={isSortable} className={rowClassName} /></div>{(footerAdditionalElement || paginator && limiter) && <div className={twJoin("flex", footerAdditionalElement ? "justify-between" : "justify-end")}>{footerAdditionalElement}{paginator && limiter && <TableLimitPagination tableRef={tableRef} nestedId={nestedId} paginationIdField={paginationIdField} rowIdParser={rowIdParser} paginator={paginator} limiter={limiter} data={data} />}</div>}</div> : <EmptyList footerAdditionalElement={footerAdditionalElement} />;
    $[3] = data;
    $[4] = emptyListWithTitles;
    $[5] = firstLineRect;
    $[6] = footerAdditionalElement;
    $[7] = isSortable;
    $[8] = limiter;
    $[9] = nestedId;
    $[10] = noHeader;
    $[11] = onRowClick;
    $[12] = paginationIdField;
    $[13] = paginator;
    $[14] = rowClassName;
    $[15] = rowIdParser;
    $[16] = testAttributePostfix;
    $[17] = totalWidth;
    $[18] = type;
    $[19] = visibleColumns;
    $[20] = withBorders;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  return t3;
}
function _temp(column) {
  return column.shouldRender !== false;
}